import type { ElementType, ReactNode } from 'react';
import { cx } from '@/lib/cx';
import styles from './ScriptLine.module.css';

export interface ScriptLineProps {
  children: ReactNode;
  size?: 'sm' | 'md' | 'lg';
  align?: 'start' | 'center' | 'end';
  as?: ElementType;
  className?: string;
}

/**
 * Linea manuscrita suelta (Allura): claims como "Somos luz. Somos origen." o
 * "Despierta tu poder. Vive tu propósito.". Para el acento DENTRO de un titular,
 * usa la prop `scriptLine` de `DisplayTitle`.
 */
export function ScriptLine({
  children,
  size = 'md',
  align = 'start',
  as: Tag = 'p',
  className,
}: ScriptLineProps) {
  return (
    <Tag
      className={cx('az-script', styles.script, styles[`size-${size}`], styles[`align-${align}`], className)}
    >
      {children}
    </Tag>
  );
}
